// extracted by mini-css-extract-plugin
module.exports = {"postWrapper":"post-section-module--postWrapper--Tpwfb","title":"post-section-module--title--2i63F","icon":"post-section-module--icon--2Ohnw"};